
import { useState, useMemo, useEffect } from "react"
import { Grid, Typography, Modal, Box, IconButton, Button, useMediaQuery } from "@mui/material"
import CloseIcon from "@mui/icons-material/Close";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import NomineeForm from "./NomineeForm";
import NomineeDistribution from "./NomineeDistribution";
import { useLocation } from "react-router-dom"
import ESignSuccess from './ESignSuccess';
import ESignFailure from './ESignFailure';
import tickmark from "../../assets/svg/nomine.png";

const NomineeModal = ({ open, setModal, handleClose }) => {
    const [expanded, setExpanded] = useState([false, false, false])
    const [savedStatus, setSavedStatus] = useState([false, false, false])
    const [nomineesData, setNomineesData] = useState([null, null, null])
    const [guardianData, setGuardianData] = useState([null, null, null])
    const [isUnderage, setIsUnderage] = useState([null, null, null]);
    const [isSameAsNominee, setIsSameAsNominee] = useState([null, null, null]);
    const [showDistribution, setShowDistribution] = useState(false)
    const isSmallScreen = useMediaQuery("(max-width : 450px)");

    const location = useLocation()
    const searchParams = useMemo(() => new URLSearchParams(location.search), [location.search])
    const successParam = searchParams.get("success")
    const isSuccess = successParam === "true"
    const isFailure = successParam === "false"


    const toggleNominee = (index) => {
        if (index === 0 || savedStatus[index - 1]) {
            setExpanded((prev) =>
                prev.map((val, i) => (i === index ? !val : false))
            );
        }
    };

    const handleSaveStatus = (index, success, nominee, guardian, minor, address) => {
        if (success) {
            const updatedSaved = [...savedStatus];
            const updatedData = [...nomineesData];
            const updatedDataOne = [...guardianData]
            const updatedDataTwo = [...isUnderage]
            const updatedDataThree = [...isSameAsNominee]

            updatedSaved[index] = true;
            updatedData[index] = nominee;
            updatedDataOne[index] = guardian;
            updatedDataTwo[index] = minor;
            updatedDataThree[index] = address;

            setSavedStatus(updatedSaved);
            setNomineesData(updatedData);
            setGuardianData(updatedDataOne)
            setIsUnderage(updatedDataTwo)
            setIsSameAsNominee(updatedDataThree)

            setExpanded([false, false, false]);
        }
    };


    const handleConfirm = () => {
        // const filledForms = nomineesData.filter((data, i) => savedStatus[i]);
        // console.log("🚀 Final Nominee Payload:", filledForms);

        setShowDistribution(true)
    }

    const isConfirmEnabled = savedStatus[0]

    useEffect(() => {
        if (successParam) {
            setModal(true)
        }
    }, [successParam])

    if (isSuccess || isFailure) {
  return (
    <Modal open={open} onClose={() => setModal(false)}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '90%', sm: '80%', md: '60%', lg: '40%' },
          backgroundColor: '#fff',
          outline: 'none',
          p: { xs: 2, sm: 3, md: 4 },
          borderRadius: '14px',
          maxHeight: '90vh',
          overflowY: 'auto'
        }}
      >
        <Box sx={{ position: 'relative', textAlign: 'center' }}>
          <IconButton
            onClick={handleClose}
            sx={{
                mt: isSmallScreen && 3,
              position: 'absolute',
              top: 8,
              right: 8,
              color: '#333333',
              background: "#e0e0e0",
              borderRadius: 1,
              '&:hover': { backgroundColor: '#d6d6d6' },
            }}
          >
            <CloseIcon sx={{ fontSize: "14px", }} />
          </IconButton>

          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 1,
              mt: 1,
              mb: 2,
              textAlign: 'center',
            }}
          >
            <img src={tickmark} alt="success" style={{ width: 24, height: 24 }} />
            <Typography
              sx={{
                color: '#000',
                fontSize: { xs: '16px', sm: '18px', md: '20px' },
                fontWeight: 600,
              }}
            >
              {isSuccess ? "E-Sign successfully completed" : "E-Sign has been Failed."}
            </Typography>
          </Box>
        </Box>

        {isSuccess && <ESignSuccess />}
        {isFailure && <ESignFailure />}
      </Box>
    </Modal>
  );
}


    return (
        <Modal open={open} onClose={() => setModal(false)}>
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: {
                        xs: '90%',
                        sm: '80%',
                        md: '70%',
                        lg: '60%',
                    },
                    maxHeight: '90vh',
                    overflowY: 'scroll',
                    scrollbarWidth: 'none',
                    '&::-webkit-scrollbar': {
                        display: 'none',
                    },
                    backgroundColor: '#fff',
                    outline: 'none',
                    p: { xs: 2, sm: 3, md: 4 },
                    borderRadius: '14px',
                }}

            >
                <Grid container justifyContent="flex-end">
                    <IconButton onClick={() => {
                        handleClose()
                        setNomineesData([null, null, null])
                        setGuardianData([null, null, null])
                        setIsUnderage([null, null, null])
                        setShowDistribution(false)
                        setSavedStatus([false, false, false])
                    }}>
                        <CloseIcon sx={{ color: '#333333' }} />
                    </IconButton>
                </Grid>

                {!showDistribution && (
                    <>
                        <Grid container mb={2}>
                            <Typography
                                sx={{ color: "#131E2E", fontSize: { xs: "16px", sm: "18px", md: "20px" }, fontWeight: "bold" }}
                            >
                                Add Nomination Details
                            </Typography>
                        </Grid>

                        <Grid container justifyContent="center" mb={2}>
                            <Typography
                                sx={{ color: "#131E2E", fontSize: { xs: "16px", sm: "18px" }, fontWeight: "bold", textAlign: "center" }}
                            >
                                Nominees for Trading & Demat account
                            </Typography>
                        </Grid>
                    </>
                )}

                {!showDistribution && [0, 1, 2].map((i) => (
                    <NomineeForm
                        key={i}
                        index={i}
                        open={expanded[i]}
                        onToggle={() => toggleNominee(i)}
                        onSave={handleSaveStatus}
                        saved={savedStatus[i]}
                    />
                ))}

                {showDistribution && savedStatus.filter(Boolean).length > 0 && (
                    <NomineeDistribution
                        nominees={nomineesData.filter((_, i) => savedStatus[i])}
                        nomineesData={nomineesData}
                        guardianData={guardianData}
                        isUnderage={isUnderage}
                    />
                )}

                {!showDistribution && (
                    <>
                        <Grid container mb={2} mt={2} alignItems="center">
                            <InfoOutlinedIcon sx={{ color: '#333333', mr: 1 }} />
                            <Typography sx={{ color: "#333333", fontSize: { xs: "14px", sm: "16px", } }}>
                                You can add up to 3 Nominees.
                            </Typography>
                        </Grid>

                        <Grid container mb={2} mt={2} alignItems="center">
                            <InfoOutlinedIcon sx={{ color: '#333333', mr: 1 }} />
                            <Typography sx={{ color: "#333333", fontSize: { xs: "14px", sm: "16px", } }}>
                                Online nomination is allowed only one time. You will not be able to modify the details later.
                            </Typography>
                        </Grid>


                        <Grid container justifyContent="center" mt={4}>
                            <Button
                                disabled={!isConfirmEnabled}
                                sx={{ color: !isConfirmEnabled && "#999 !important", fontWeight: 600 }}
                                onClick={handleConfirm}
                            >
                                Confirm and Proceed
                            </Button>
                        </Grid>
                    </>
                )}
            </Box>
        </Modal>
    )
}

export default NomineeModal
